<template>
  
  <div class="justify-content-center">
    <b-button pill variant="outline-secondary" @click="voltar">
          <font-awesome-icon type="submit" :icon="['fa', 'arrow-left']" />
          Voltar
    </b-button>
    <div class="mt-2 mb-4 d-flex justify-content-center">
      <div class="line"></div>
      <div style="margin-top: 0.5rem">
        <h5>
          <strong>{{ titulo }}</strong>
        </h5>
      </div>
      <div class="line"></div>
    </div>
    <b-row class="mb-2">
      <b-col
        class="py-2"
        cols="md-6 sm-12"
        v-for="(item, key) in rotas"
        :key="key"
      >
        <b-card
          no-body
          img-left
          class="sub-menu-card shadow"
          @click="clickCard(item.name)"
        >
          <b-card-header
            class="bg-transparent d-flex align-items-center border-0"
          >
            <font-awesome-icon
              :icon="[item.icone.tipo, item.icone.nome]"
              size="3x"
            />
          </b-card-header>
 
          <b-card-body class="d-flex align-items-center">
            <b-card-title>{{ item.titulo }}</b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card class="shadow border-white">
          <b-card-text>
            <h6 align="center" class="text-primary"><p>ORIENTAÇÕES</p></h6>
            <ul>
              <li>
                <p>
                  Para realizar as consultas é necessário estar logado com
                  usuário no GOV.br. Para mais detalhes sobre o GOV.br,
                  <b-link
                    target="_blank"
                    class="text-primary"
                    href="http://faq-login-unico.servicos.gov.br/en/latest/_perguntasdafaq/oquee.html"
                    >acesse aqui</b-link
                  >
                </p>
              </li>
              <li>
                <p>
                  Estão disponíveis para consulta e emissão de guia de pagamento¹, as multas de trânsito (Autos de Infração de Trânsito) lavradas dentro do município de Belo Horizonte e emitidas pela PBH - Prefeitura de Belo Horizonte².
            </p></li>
              <li><p>
                É possível consultar suas multas informando Placa e RENAVAM
                (vide acima opção de 
                <b-link class="text-primary" @click="clickCard('PlacaRenavamView')">Consulta por Placa e RENAVAM</b-link>).
            </p></li>
              <li><p>
                Também é possível consultar as multas em que o CPF do usuário
                logado no GOV.br seja o proprietário do veículo (vide acima a
                opção <b-link class="text-primary" @click="clickCard('CpfCnpjView')">Consulta por CPF ou CNPJ do Proprietário</b-link>).
            </p></li>
              <li><p>
                Para multas canceladas, será permitida a visualização somente se
                for informado um destes campos:
                <ul>
                  <li>Número do AIT (Auto de Infração de Trânsito);</li>
                  <li>Número de Processamento (número de identificação da multa no DETRAN-MG);</li>
                  <li>Número da Notificação;</li>
                  <li>Código Lançamento (número de identificação da multa pela Secretaria Municipal de Fazenda / PBH);</li>
                </ul>
            </p></li>      
            </ul>
            <div class="line"></div>
            <p class="pl-3 text-secondary" style="font-size:small;">
                <em>(¹) Emissão de Guia de Pagamento (DRAM - Documento de Recolhimento e Arrecadação Municipal):</em>
                <ul>
                  <li><em>Logado com o usuário GOV.br, nesse portal, é possível emitir guia de pagamento para multa de trânsito não inscrita em Dívida Ativa</em></li>
                  <li><em>Se sua multa está inscrita em Dívida Ativa, emita sua guia para pagamento conforme orientações do serviço: 
                    <b-link
                    target="_blank"
                    class="text-primary"
                    href="https://servicos.pbh.gov.br/servicos/i/5fa3f72d0ceeee0a7e69ad9a/5dc8470253fd6b5bbd99185f/servicos%2Bguias-multa-de-transito-inscritas-em-divida-ativa"
                    >Guias - Multa de Trânsito - Inscritas em Dívida Ativa</b-link
                  ></em></li>
                  <li><em>Se você não possui usuário GOV.br,  para multa de trânsito não inscrita em Dívida Ativa, você consegue também emitir sua guia de pagamento por esses meios:
                    <ul><li><b-link
                    target="_blank"
                    class="text-primary"
                    href="https://servicos.pbh.gov.br/servicos/i/5fdb7b00bbfc827e9ece9aea/5dc8470253fd6b5bbd99185f/servicos+guias-multa-de-transito-nao-inscritas-em-divida-ativa"
                    >Guias - Multa de Trânsito - Não Inscritas em Dívida Ativa</b-link
                  ></li>
                  <li><b-link
                    target="_blank"
                    class="text-primary"
                    href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/emitir-de-extrato-de-multas"
                    >DETRAN - MG - Emitir Boleto de Multa</b-link
                  ></li></ul>
                  </em></li>
                </ul>
                

                <em>(²) A multa de trânsito pode ser emitida pelo DETRAN-MG ou por outras instâncias. Avalie a 
                
                <b-link
                  target="_blank"
                  class="text-primary"
                  href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/consultar-situacao-do-veiculo"
                  >Situação do veículo no DETRAN-MG</b-link
                >
              </em>
            </p>
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import helpers from "@/helpers";
export default {
  name: "SubMenuBody",
  props: {
    titulo: { type: String, default: "" },
    rotas: {
      type: Array,
      default: () => {
        return [];
      },
    },
    orientacoes: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  computed: {
    mobile() {
      return helpers.isMobile();
    },
  },

  methods: {
    clickCard(rotaName) {
      this.$emit("clickCard", rotaName);
    },
    voltar() {
      this.$router.push({
        name: "HomeView",
      });
    },
  },
};
</script>

<style scoped>
.sub-menu-card {
  cursor: pointer;
  height: 100%;
  border-radius: 25px;
  border-color: white;
  border-top: 0.2rem solid;
  border-top-color: black;
}
</style>